// this file is generated by generate-icons.js. Do not edit!
import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const SVGExternalLink = props => /*#__PURE__*/_jsxs("svg", Object.assign({
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink"
}, props, {
  children: [/*#__PURE__*/_jsx("defs", {
    children: /*#__PURE__*/_jsx("path", {
      d: "M8.761 3.69c.765 0 1.384.618 1.384 1.383 0 .764-.619 1.383-1.384 1.383h-5.61c-.212 0-.384.173-.384.384v13.988c0 .211.172.384.384.384h13.987c.212 0 .385-.173.385-.384v-5.61c0-.765.619-1.384 1.383-1.384.765 0 1.384.62 1.384 1.384v5.61c0 1.737-1.414 3.151-3.152 3.151H3.151C1.414 23.98 0 22.565 0 20.828V6.84c0-1.738 1.414-3.15 3.151-3.15zM22.596 0c.178 0 .347.037.504.099l.02.005c.166.069.32.168.453.301.134.134.234.289.301.453l.007.02c.061.157.098.327.098.505v8.393c0 .765-.62 1.383-1.383 1.383-.765 0-1.384-.618-1.384-1.383V4.723l-11.78 11.78c-.27.27-.624.405-.978.405s-.708-.135-.979-.405c-.54-.54-.54-1.417 0-1.956l11.78-11.78h-5.053c-.763 0-1.383-.619-1.383-1.384 0-.764.62-1.383 1.383-1.383z",
      id: "externalLink__a"
    })
  }), /*#__PURE__*/_jsx("use", {
    xlinkHref: "#externalLink__a",
    fillRule: "evenodd"
  })]
}));
SVGExternalLink.displayName = 'SVGExternalLink';
export default SVGExternalLink;